module.exports = __webpack_public_path__ + "static/media/otago_madinah.deb4b1cb.png";